<template>
  <!-- <v-parallax src=""> -->
  <v-layout column fill-height
    :style="[
      {'background-image': `url('${require('@/assets/background-login.jpg')}')`},
      {'background-repeat': 'repeat'}
    ]"
  >
    <v-flex fill-height>
      <v-container id="login" fill-height>
        <v-layout row wrap>
          <v-flex xs12 md6>
            <v-layout column>
              <v-flex xs4 md4>
                <v-layout>
                  <v-flex xs4 md4 offset-xs4 offset-md0>
                    <v-layout justify-center>
                      <img width="140px" height="100px" :src="require('@/assets/logotipo.png')">
                    </v-layout>
                  </v-flex>
                  <v-flex xs4 md8></v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs8 md4 offset-sm2>
                <v-layout column justify-center class="py-3">
                  <div id="brand-message-title" class="text-sm-left">
                    {{brandMessage.title}}
                  </div>
                  <div id="brand-message-subtitle">
                    {{brandMessage.subtitle}}
                  </div>
                </v-layout>
              </v-flex>
              <v-flex xs0 md4></v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm8 md5 offset-sm2 offset-md1>
            <v-layout class="align-center">
              <v-flex>
                <v-form @submit="logIn($event)">
                  <v-card class="px-4 pt-4">
                    <v-card-media :contain="true" :src="require('@/assets/logotipo-strategio.png')" height="120px">
                    </v-card-media>
                    <v-card-text>
                      <v-text-field
                        id="txtUser"
                        name="txtUser"
                        label="Usuario"
                        prepend-icon="person_outline"
                      ></v-text-field>
                      <v-text-field
                        id="txtPassword"
                        name="txtPassword"
                        label="Password"
                        prepend-icon="lock_outline"
                        :append-icon="hidePassword ? 'visibility' : 'visibility_off'"
                        :append-icon-cb="() => (hidePassword = !hidePassword)"
                        :type="hidePassword ? 'password' : 'text'"
                      ></v-text-field>
                      <div class="strategio-login-error-message">
                        {{errorMessage}}
                      </div>
                      <div>
                        <v-btn
                          style="background-color:#2FC7DE;color:black;font-size:12px;"
                          block large round depressed
                          class="mx-0"
                          type="submit"
                          :loading="isLoading"
                          @click.native="loader = 'loading'"
                          :disabled="isLoading"
                        >
                          Ingresar
                        </v-btn>
                      </div>
                      <!-- <div class="_poweredBy">
                        <v-icon color="amber darken-1">flash_on</v-icon>Powered by <a href="http://www.vida.software/" target="__BLANK">Vida Software</a>
                      </div> -->

                    </v-card-text>
                  </v-card>
                </v-form>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>

    </v-flex>
    <v-footer
      class="px-4 mb-2"
      color="transparent"
      style="font-size:10px;color:white;"
    >
      © TODOS LOS DERECHOS RESERVADOS - VIDA SOFTWARE
    </v-footer>
  </v-layout>

  <!-- </v-parallax> -->
  <!-- <div>
    <v-container>
      <v-layout row wrap>
        <v-flex xs12 sm8 md8 lg6 xl4 offset-sm2 offset-md2 offset-lg3 offset-xl4>
          
        </v-flex>
      </v-layout>
    </v-container>
  </div> -->
</template>

<script>
import auth from '../utils/auth'
import storageCleaner from '../utils/storageCleaner'

export default {
  name: 'login',
  data () {
    delete localStorage.token
    delete localStorage.user
    storageCleaner.cleanStorage()
    return {
      msg: 'Welcome to Your Vue.js App',
      hidePassword: true,
      errorMessage: '',
      isLoading: false,
      brandMessage: {
        title: '¿Cuanto vendiste ayer?',
        subtitle: 'Strategio. Porque solo se puede controlar lo que se mide.'
      }
    }
  },
  methods: {
    logIn (e) {
      e.preventDefault()
      this.errorMessage = ''
      this.isLoading = true

      const user = document.getElementById('txtUser').value
      const password = document.getElementById('txtPassword').value
      auth.login({
        context: this,
        creds: {user, password},
        onSuccess: (response) => {
          this.isLoading = false

          if (response.data.user.userType === 'SUPERVISOR') {
            this.$router.push('/supervise/dashboard')
          } else {
            this.$router.push('/0')
          }
        },
        onError: (error) => {
          this.isLoading = false
          let errMessage = 'Error desconocido'
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log(error.response.data)
            errMessage = error.response.data.message
            // console.log(error.response.status);
            // console.log(error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request)
            errMessage = 'No pudimos obtener respuesta del servidor'
          } else {
            // Something happened in setting up the request that triggered an Error
            errMessage = `Error desconocido: ${error.errorMessage}`
          }
          this.errorMessage = errMessage
          console.log(error.config)
        }
      })
      return false
    }
  }
}
</script>
<style>
.strategio-login-error-message {
  text-align: center;
  color: #F44336;
}
._poweredBy {
  margin-top: 16px;
  text-align: right;
  font-weight: 600;
}
#brand-message-title {
  font-size: 4vw;
  font-weight: bold;
  /* text-align: right; */
  color: white;
}

#brand-message-subtitle {
  font-size: 2vh;
  font-weight: normal;
  text-align: start;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/routes/login.vue